// PosSuccessScreen.tsx — Écran de confirmation de vente (plein écran)
// À déposer dans : src/gestion-pos/PosSuccessScreen.tsx
// OPTIONNEL : reproduit l'écran de succès de la maquette. Si tu préfères garder ton
// <TicketCaisse /> existant comme confirmation, n'utilise pas ce composant (cf. README).
// Sinon, affiche-le après une vente réussie et câble onPrint sur ton impression.
import React from "react";
import { Icon, fmt, PosSaleResult } from "./posMobileShared";

export interface PosSuccessScreenProps {
  sale: PosSaleResult;
  warehouseName?: string;
  onNew: () => void;
  onPrint?: () => void;
}

export default function PosSuccessScreen({ sale, warehouseName, onNew, onPrint }: PosSuccessScreenProps) {
  return (
    <div className="pos-done">
      <div className="pos-done-body">
        <div className="pos-burst"><Icon name="check" size={42} stroke={2.6} /></div>
        <div className="pos-done-t">Vente encaissée</div>
        <div className="pos-done-s">
          Le ticket est prêt. Stock mis à jour{warehouseName ? <><br />pour {warehouseName}.</> : "."}
        </div>

        <div className="pos-ticket">
          <div className="pos-ticket-head">
            <div className="pos-ticket-ref">Ticket de caisse</div>
            <div className="pos-ticket-num">{sale.ref}</div>
          </div>
          <div className="pos-ticket-body">
            <div className="pos-ticket-row"><span className="l">Articles</span><span className="v">{sale.count}</span></div>
            <div className="pos-ticket-row"><span className="l">Client</span><span className="v">{sale.client}</span></div>
            <div className="pos-ticket-row"><span className="l">Paiement</span><span className="v">{sale.methodLabel}</span></div>
            {sale.isCash && (
              <>
                <div className="pos-ticket-row"><span className="l">Reçu</span><span className="v">{fmt(sale.received)} F</span></div>
                <div className="pos-ticket-row change"><span className="l">Rendu</span><span className="v">{fmt(sale.change)} F</span></div>
              </>
            )}
            <div className="pos-ticket-row total"><span className="l">Total</span><span className="v">{fmt(sale.total)} F</span></div>
          </div>
        </div>
      </div>
      <div className="pos-done-foot">
        <button className="pos-ghost-print" onClick={onPrint}><Icon name="printer" size={20} stroke={1.9} />Ticket</button>
        <button className="pos-newsale" onClick={onNew}><Icon name="plus" size={20} stroke={2.3} />Nouvelle vente</button>
      </div>
    </div>
  );
}
